import { Column, EditType } from '@src/model/table';
import { Address } from '@src/dtos/version.dto';
import { AddressIPType, getCustomEnumOptions } from '@src/utils/enums';
import { createIPAddressColumn, createIPTypeColumn } from '@src/components/shared/table/column-factories';
import { useStores } from '@src/components/store';

export const useIpListColumns = ():Column<Address>[] => {
    const {customerStore} = useStores();

    return [
        {
            ...createIPTypeColumn(),
            type: EditType.RadioButton,
            options: () => getCustomEnumOptions(AddressIPType).filter(v => v.value !== AddressIPType.IP_RANGE),
            isKeyField: true,
        },
        createIPAddressColumn(customerStore)
    ] as Column<Address>[];
};
